<template>
    <el-container id="tab">
        <el-aside class="aside-box" :width="isCollapse ? '20px' : '320px'">
            <el-card v-show="!isCollapse" shadow="never">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane label="查询条件" name="query">
                        <el-form label-width="80px" :model="queryForm" ref="queryFormRef" status-icon>
                            <el-scrollbar>
                                <!-- <el-form-item label="单据类型" prop="dateType.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.dateType.selected" clearable placeholder="请选择">
                                        <el-option key="A" label="单据日期" value="A"></el-option>
                                        <el-option key="B" label="制单日期" value="B"></el-option>
                                        <el-option key="C" label="审核日期" value="C"></el-option>
                                    </el-select>
                                </el-form-item> -->
                                <el-form-item prop="billDate.selected" style="margin-left: -80px;">
                                    <div class="date-box" style="display: flex;">
                                        <el-select style="width: 90px !important;flex: 0 0 auto;" v-model="queryForm.dateType.selected" placeholder="请选择">
                                            <el-option key="A" label="单据日期" value="A">
                                                <div class="label-box-item">
                                                    <div>单据日期</div>
                                                    <el-tooltip class="item" effect="dark" content="访销签收日期" placement="right">
                                                        <span class="icon iconfont icon-a-bangzhu2" style="color: #ff9000;"></span>
                                                    </el-tooltip>
                                                </div>
                                            </el-option>
                                            <el-option key="B" label="制单日期" value="B">
                                                <div class="label-box-item">
                                                    <div>制单日期</div>
                                                    <el-tooltip class="item" effect="dark" content="访销签收时间" placement="right">
                                                        <span class="icon iconfont icon-a-bangzhu2" style="color: #ff9000;"></span>
                                                    </el-tooltip>
                                                </div>
                                            </el-option>
                                            <el-option key="C" label="审核日期" value="C">
                                                <div class="label-box-item">
                                                    <div>审核日期</div>
                                                    <el-tooltip class="item" effect="dark" content="访销签收时间" placement="right">
                                                        <span class="icon iconfont icon-a-bangzhu2" style="color: #ff9000;"></span>
                                                    </el-tooltip>
                                                </div>
                                            </el-option>
                                        </el-select>
                                        <date-picker style="width: 100%;" v-model="queryForm.billDate.selected" type="daterange"
                                            align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                                            end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                                        </date-picker>
                                    </div>
                                </el-form-item>
                                <el-form-item label="单据类型" prop="billType.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.billType.selected" clearable placeholder="请选择">
                                        <el-option label="销售单" value="A"></el-option>
                                        <el-option label="还货单" value="B"></el-option>
                                        <el-option label="退货单" value="C"></el-option>
                                        <el-option label="换货单" value="D"></el-option>
                                        <el-option v-if="power.isOpenPromotionSale == 'Y'" label="访销单" value="E"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="大类" prop="brand.selected">
                                    <select-multiple style="width: 100%;" v-bind:select-data="queryForm.brand"
                                        :change="brandChange"></select-multiple>
                                </el-form-item>
                                <el-form-item label="小类" prop="brandType.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.brandType"></select-multiple>
                                </el-form-item>
                                <el-form-item label="商品" prop="product.selected">
                                    <el-select class="select_multiple" ref="productSelectRef" style="width: 100%;"
                                        v-model="queryForm.product.selected" value-key="value" multiple clearable
                                        placeholder="请选择商品名称" @click.native="productInputFocus">
                                        <el-option v-for="item in queryForm.product.list" :key="item.value"
                                            :label="item.text" :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="品牌" prop="financialBrand.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.financialBrand"></select-multiple>
                                </el-form-item>
                                <el-form-item label="所属片区" prop="domainDesc.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.domainDesc"></select-multiple>
                                </el-form-item>
                                <el-form-item label="客户" prop="customer.selected">
                                    <!-- <select-multiple style="width: 100%;" v-bind:select-data="queryForm.customer"></select-multiple> -->
                                    <el-select style="width: 100%;" class="select_multiple query_form_item" ref="customerSelectRef"
                                        v-model="queryForm.customer.selected" value-key="value" multiple clearable
                                        placeholder="请选择客户名称" @click.native="customerInputFocus">
                                        <el-option v-for="item in queryForm.customer.list" :key="item.value"
                                            :label="item.text" :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="客户标签" prop="label.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.label.selected" filterable multiple value-key="id" placeholder="请选择客户标签">
                                        <el-option v-for="item in queryForm.label.list" :key="item.id" :label="item.labelDesc" :value="item">
                                        <span>{{ item.labelDesc }}({{ item.shortName }})</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="服务员工" prop="serviceUserId.selected">
                                    <select-multiple style="width: 100%;" v-bind:select-data="queryForm.serviceUserId"></select-multiple>
                                </el-form-item>
                                <el-form-item label="建档人" prop="entryUserId.selected">
                                    <select-multiple style="width: 100%;" v-bind:select-data="queryForm.entryUserId"></select-multiple>
                                </el-form-item>
                                <el-form-item label="客户等级" prop="customerLevel.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.customerLevel.selected" clearable placeholder="请选择">
                                        <el-option label="A类客户" value="A"></el-option>
                                        <el-option label="B类客户" value="B"></el-option>
                                        <el-option label="C类客户" value="C"></el-option>
                                        <el-option label="D类客户" value="D"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="客户状态" prop="customerStatus.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.customerStatus.selected" clearable placeholder="请选择">
                                        <el-option label="正常" value="Y"></el-option>
                                        <el-option label="作废" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否新店" prop="isNewShop.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isNewShop.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="新成交客户" prop="isNewCustomer.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isNewCustomer.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="商品类型" prop="productLabelIds.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.productLabelIds.selected" filterable multiple value-key="value" placeholder="请选择商品类型">
                                        <el-option v-for="item in queryForm.productLabelIds.list" :key="item.value" :label="item.text" :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="商品优先级" prop="productClassification.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.productClassification.selected" clearable placeholder="请选择">
                                        <el-option label="A级" value="A"></el-option>
                                        <el-option label="B级" value="B"></el-option>
                                        <el-option label="C级" value="C"></el-option>
                                        <el-option label="D级" value="D"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="商品包装" prop="isScatterProduct.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isScatterProduct.selected" clearable placeholder="请选择">
                                        <el-option label="定量" value="A"></el-option>
                                        <el-option label="散称包装" value="B"></el-option>
                                        <el-option label="散称裸货" value="C"></el-option>
                                        <el-option label="散称干果" value="D"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="价格带" prop="priceBandLabelId.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.priceBandLabelId.selected" filterable multiple value-key="value" placeholder="请选择价格带">
                                        <el-option v-for="item in queryForm.priceBandLabelId.list" :key="item.value" :label="item.text" :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否为物料" prop="isMaterial.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isMaterial.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否统计缸数" prop="countTankStats.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.countTankStats.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="供应商" prop="supplierID.selected">
                                    <select-multiple style="width: 100%;" :select-data="queryForm.supplierID"></select-multiple>
                                </el-form-item>
                                <el-form-item label="业务员" prop="salesman.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.salesman"></select-multiple>
                                </el-form-item>
                                <el-form-item label="配送员" prop="deliverUser.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.deliverUser"></select-multiple>
                                </el-form-item>
                                <el-form-item label="所属公司" prop="subCompanyID.selected" v-if="!isSettlementCustomer">
                                    <select-multiple style="width: 100%;" :select-data="queryForm.subCompanyID"
                                        is-scroll></select-multiple>
                                </el-form-item>
                                <el-form-item label="结算单位" prop="settlementCustomerId.selected" v-if="isSettlementCustomer">
                                    <select-multiple :select-data="queryForm.settlementCustomerId" key="settlementCustomerId"></select-multiple>
                                </el-form-item>
                                <el-form-item label="客户类别" prop="customerTypes.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.customerTypes"></select-multiple>
                                </el-form-item>
                                <el-form-item label="销售形式" prop="isLargess.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.isLargess"></select-multiple>
                                </el-form-item>
                                <el-form-item label="退货原因" prop="causeId.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.causeId"></select-multiple>
                                </el-form-item>
                                <el-form-item label="部门" prop="departmentID.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.departmentID"></select-multiple>
                                </el-form-item>
                                <el-form-item label="库房" prop="warehouseID.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.warehouseID"></select-multiple>
                                </el-form-item>
                                <el-form-item label="支付方式" prop="accountType.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.accountType"></select-multiple>
                                </el-form-item>
                                <el-form-item label="是否新品" prop="isNewProduct.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isNewProduct.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="单据来源" prop="isFromVehicle.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isFromVehicle.selected" clearable placeholder="请选择">
                                        <el-option label="手机端" value="Y"></el-option>
                                        <el-option label="电脑端" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="清欠情况" prop="arrearType.selected">
                                    <!-- <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.isLargess"></select-multiple> -->
                                    <el-select style="width: 100%;" v-model="queryForm.arrearType.selected" multiple clearable placeholder="请选择">
                                        <el-option key="A" label="现结" value="A"></el-option>
                                        <el-option key="B" label="已清欠" value="B"></el-option>
                                        <el-option key="E" label="部分清欠" value="E"></el-option>
                                        <el-option key="C" label="未清欠未对账" value="C"></el-option>
                                        <el-option key="D" label="未清欠已对账" value="D"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="isReturnCause.selected">
                                    <el-checkbox v-model="queryForm.isReturnCause.selected" true-label="Y" false-label="">只显示退货二次销售商品</el-checkbox>
                                </el-form-item>
                                <!-- <el-form-item label="备注" prop="remark.selected">
                                    <el-input placeholder="请输入备注" v-model.trim="queryForm.remark.selected" clearable></el-input>
                                </el-form-item> -->
                            </el-scrollbar>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">查询</el-button>
                                <el-button @click="onReset">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="组合" name="combination" v-if="params.code != 'billNo'">
                        <div class="table-header">
                            <p>组合名</p>
                            <p>是否收藏</p>
                        </div>
                        <div class="table-list">
                            <div class="item" v-for="(item, index) in tabsNavList[tabsIndex].subList" :key="index">
                                <p :class="makeUpIndex == index ? 'active' : ''" @click="toMakeUp(item, index)">
                                    {{ item.name }}</p>
                                <!-- <el-switch v-model="item.isSelect" inactive-value="N" active-value="Y" ></el-switch> -->
                                <i class="el-icon-star-on" style="font-size: 26px; cursor: pointer;"
                                    :style="{ color: item.isSelect == 'Y' ? '#409EFF' : '#CCCCCC' }"
                                    @click="toSelect(index)"></i>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <el-button style="position: absolute; top: 11px;right: 20px; padding: 0; font-size: 15px;"
                    icon="el-icon-d-arrow-left" type="text" @click="setEnter"></el-button>
            </el-card>
            <div class="isCollapse" v-show="isCollapse" @click="setEnter">
                <span style="text-align: center;">查询</span>
                <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
                <span style="text-align: center;">条件</span>
            </div>
        </el-aside>
        <el-main class="main-box">
            <el-tabs type="border-card" v-model="tabsName" @tab-click="handleClick" class="tabs-card">
                <el-card shadow="never" style="position: relative;">
                    <el-form :inline="true" style="height: 41px; overflow-y: auto; width: calc(100% - 70px);">
                        <el-form-item label="日期范围">
                            {{ params.beginDate }}
                            <span style="margin: 0 6px;">至</span>
                            {{ params.endDate }}
                        </el-form-item>
                        <!-- <el-form-item label="业务员:">
                            {{salesman}}
                        </el-form-item> -->
                        <el-form-item style="position: absolute; top: 5px; right: 12px;">
                            <el-button type="success" size="medium" style="margin-right: 6px;"
                                @click="exportExcel">导出</el-button>
                            <el-button type="success" size="medium" style="margin-right: 6px;"
                                @click="exportExcel('Y')" v-if="params.code != 'billNo'">拆分导出</el-button>
                            <el-dropdown split-button type="primary" size="medium" trigger="click" @command="handleCommand" v-if="params.code != 'billNo'">
                                收藏列表
                                <el-dropdown-menu slot="dropdown">
                                    <template v-if="selectList.length > 0">
                                        <div style="height: 300px;">
                                            <el-scrollbar style="height: 100%;">
                                                <el-dropdown-item v-for="(item, index) in selectList" :key="index"
                                                    :command="item">{{ item.name }}</el-dropdown-item>
                                            </el-scrollbar>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <p style="height: 60px;line-height: 60px;padding: 12px; font-size: 13px;">暂无数据</p>
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-tab-pane :label="item.name" :name="item.code" v-for="(item, index) in tabsNavList" :key="index">
                    <saleReportTableBill v-if="item.code == 'billNo'" :ref="item.code" :arguments="params" :tag="item.code"
                        :tableHeaderList="tableHeaderList" :customColumnsList="customColumnsList"
                        :transmitQuery="transmitQuery"
                        @columns="getCustomColumns" :funcCode="funcCode" @onSubmit="onSubmit"></saleReportTableBill>
                    <saleReportTable v-else :ref="item.code" :arguments="params" :tag="item.code"
                        :tableHeaderList="tableHeaderList" :customColumnsList="customColumnsList"
                        :transmitQuery="transmitQuery"
                        @columns="getCustomColumns" :funcCode="funcCode" @onSubmit="onSubmit"></saleReportTable>
                </el-tab-pane>
                <!-- <el-tab-pane label="品牌" name="brand">
                    <saleReportTable ref="brand" :arguments="params" tag="brand"></saleReportTable>
                </el-tab-pane>
                <el-tab-pane label="类别" name="type">
                    <saleReportTable ref="type" :arguments="params" tag="type"></saleReportTable>
                </el-tab-pane>
                <el-tab-pane label="客户" name="customer">
                    <saleReportTable ref="customer" :arguments="params" tag="customer"></saleReportTable>
                </el-tab-pane>
                <el-tab-pane label="片区" name="domain">
                    <saleReportTable ref="domain" :arguments="params" tag="domain"></saleReportTable>
                </el-tab-pane>
                <el-tab-pane label="渠道" name="channel">
                    <saleReportTable ref="channel" :arguments="params" tag="channel"></saleReportTable>
                </el-tab-pane>
                <el-tab-pane label="业务" name="salesman">
                    <saleReportTable ref="salesman" :arguments="params" tag="salesman"></saleReportTable>
                </el-tab-pane>
                <el-tab-pane label="部门" name="department">
                    <saleReportTable ref="department" :arguments="params" tag="department"></saleReportTable>
                </el-tab-pane>
                <el-tab-pane label="库房" name="warehouse">
                    <saleReportTable ref="warehouse" :arguments="params" tag="warehouse"></saleReportTable>
                </el-tab-pane> -->
            </el-tabs>
        </el-main>
        <el-dialog title="自定义显示列" :visible.sync="dialogVisible" :close-on-click-modal="false" width="20%">
            <custom-columns ref="customColumns" v-if="dialogVisible" :draggable="true" @confirm="dialogClose"></custom-columns>
        </el-dialog>
    </el-container>
</template>
<script>
import datePicker from '@/components/common/datePicker.vue'
import customColumns from '@/components/common/customColumns.vue'
import saleReportTable from '@/components/dataSearch/saleReportTable.vue'
import saleReportTableBill from '@/components/dataSearch/saleReportTableBill.vue'
import { pickerOptions, getNowFormatDate, getAddDate, debounce } from '@/assets/js/common.js'

// ==================== 需求#154：客户/商品维度列表列（自定义列，默认隐藏） ====================
// 涉及客户维度的统计：客户 8 列
const CUSTOMER_DIM_COLUMNS = [
    { label: "服务员工", prop: "serviceUserName" },
    { label: "建档人", prop: "customerEntryUserName" },
    { label: "客户等级", prop: "customerLevel" },
    { label: "客户标签", prop: "customerLabel" },
    { label: "结算单位", prop: "settlementCustomerName" },
    { label: "新成交客户", prop: "isNewCustomerName" },
    { label: "是否新店", prop: "isNewShopName" },
    { label: "客户状态", prop: "customerStatus" }
]
// 涉及商品维度的统计：商品 7 列
const ITEM_DIM_COLUMNS = [
    { label: "商品类型", prop: "productLabelName" },
    { label: "商品优先级", prop: "productClassification" },
    { label: "商品包装", prop: "isScatterProductName" },
    { label: "价格带", prop: "priceBandLabelName" },
    { label: "是否为物料", prop: "isMaterialName" },
    { label: "是否统计缸数", prop: "countTankStatsName" },
    { label: "供应商", prop: "supplierName" }
]
export default {
    name: "SaleCollectQuery",
    props: ['option'],
    components: {
        datePicker,
        customColumns,
        saleReportTable,
        saleReportTableBill
    },
    data() {
        return {
            //左边
            activeName: 'query',
            value: true,
            isCollapse: true, //true 不展开
            pickerOptions: pickerOptions,
            queryForm: {
                dateType: { submitName: 'dateType', selected: 'A' },
                billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
                product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                departmentID: { submitName: 'departmentID', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择部门', request: { url: '/Account/departmentDefine/selectDepartmentDownListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: ''}},
                brand: { submitName: 'brandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
                financialBrand: { submitName: 'financialBrandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isEnabled: 'Y' }, text: '', value: '' } },
                brandType: { submitName: 'itemTypeID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: true, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
                salesman: { submitName: 'salesmanID', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
                deliverUser: { submitName: 'deliverUserID', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择配送员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
                domainDesc: { submitName: 'domainID', selected: [], valueIsObj: true,isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择所属片区', request: { url: '/Account/domainDefine/getDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                subCompanyID: { submitName: 'subCompanyID', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: true, list: [], label: 'label', value: 'value', placeholder: '请选择所属公司', request: { url: '/Account/customerDefineVue/selectChainStoresList.html', type: 'post', params: { page: 1, size: 10 }, text: '', value: '' } },
                settlementCustomerId: { submitName: 'settlementCustomerId', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], label: 'text', value: 'value', placeholder: '请选择结算单位', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                customer: { submitName: 'customerID', valueIsObj: true, selected: [], isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                customerTypes: { submitName: 'classifyID', selected: [], valueIsObj: true,isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户类别', request: { url: '/Account/customerTypeDefine/getCustomerTypesForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                isLargess: { submitName: 'isLargess', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择销售形式', request: { url: '/Account/salSaleType/querySalSaleList.html', type: 'post', params: { page: 1, size: 100, isPage: 'N' }, text: '', value: '' } },
                accountType: { submitName: 'accountType', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择支付方式', request: { url: '/Account/dataSearchVue/selectAccountType.html', type: 'post', params: { page: 1, size: 100, isPage: 'N', isShowCash: 'Y' }, text: '', value: '' } },
                causeId: { submitName: 'causeId', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: false, isReSearch: false, list: [], placeholder: '请选择退货原因', request: { url: '/Account/returnCaseDefine/selectReturnCaseNew.html', type: 'post', params: { }, text: '', value: '' } },
                warehouseID: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll:false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
                isNewProduct: { submitName: 'isNewProduct', selected: [] },
                isFromVehicle: { submitName: 'isFromVehicle', selected: [] },
                arrearType: { submitName: 'arrearType', selected: [] },
                isReturnCause: { submitName: 'isReturnCause', selected: '' },
                billType: { submitName: 'billType', selected: [] },
                label: { submitName: 'label', selected: [], list: [], valueIsObj: true},
                // ==================== 客户/商品维度查询条件（需求#154） ====================
                serviceUserId: { submitName: 'serviceUserId', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择服务员工', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
                entryUserId: { submitName: 'entryUserId', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择建档人', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
                customerLevel: { submitName: 'customerLevel', selected: '' },
                customerStatus: { submitName: 'customerStatus', selected: '' },
                isNewShop: { submitName: 'isNewShop', selected: '' },
                isNewCustomer: { submitName: 'isNewCustomer', selected: '' },
                productLabelIds: { submitName: 'productLabelIds', selected: [], list: [], valueIsObj: true, isMultiple: true, placeholder: '请选择商品类型' },
                productClassification: { submitName: 'productClassification', selected: '' },
                isScatterProduct: { submitName: 'isScatterProduct', selected: '' },
                priceBandLabelId: { submitName: 'priceBandLabelId', selected: [], list: [], valueIsObj: true, isMultiple: true, placeholder: '请选择价格带' },
                isMaterial: { submitName: 'isMaterial', selected: '' },
                countTankStats: { submitName: 'countTankStats', selected: '' },
                supplierID: { submitName: 'supplierID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], label: 'text', value: 'value', placeholder: '请选择供应商', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5, customerType: 'V' }, text: '', value: '' } }
                // remark: { submitName: 'remark', selected: '' }
            },
            salesman: '全部',
            params: {
                beginDate: getAddDate(-3),
                endDate: getNowFormatDate(),
                code: null,
                page: 1,
                size: 20,
                url: '/erpnew/account/c/reada46ceb/sale/collect/selectSaleCollectList.html',
            },
            makeUpIndex: null,
            //右边
            tabsName: 'itemID',
            tabsIndex: 0,
            tabsNavList: [{
                name: "商品",
                code: "itemID",
                subList: [],
                list: []
            }, {
                name: "业务",
                code: "salesmanID",
                subList: [],
                list: []
            }, {
                name: "客户",
                code: "customerID",
                subList: [],
                list: []
            }, {
                name: "大类",
                code: "brandID",
                subList: [],
                list: []
            }, {
                name: "小类",
                code: "itemTypeID",
                subList: [],
                list: []
            }, {
                name: "品牌",
                code: "financialBrandID",
                subList: [],
                list: []
            }, {
                name: "部门",
                code: "departmentID",
                subList: [],
                list: []
            }, {
                name: "片区",
                code: "domainID",
                subList: [],
                list: []
            }, {
                name: "客户类别(渠道)",
                code: "classifyID",
                subList: [],
                list: []
            }, {
                name: "商品(销售形式)",
                code: "isLargess",
                subList: [],
                list: []
            }, {
                name: "库房",
                code: "warehouseID",
                subList: [],
                list: []
            }, {
                name: "单据",
                code: "billNo",
                subList: [],
                list: []
            }],
            allowCostPrice: true,
            priceArgs: {
                url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
                code: 'isSaleReport'
            },
            dialogVisible: false,
            summaries: {},
            tableColumnList: [],
            selectList: [],
            tableHeaderList: [],
            //弹窗
            selectProductVisible: false,
            customColumnsList: [],
            funcCode: 642,
            selectLabelList: [],
            isSettlementCustomer: false, // 是否开启结算单位
            // 传过去的数据
            transmitQuery: {},
            power: {}
        }
    },
    created() {
        this.getEntrySet()
        this.getComposeList()
        this.getSelectList()
        this.isSettlementCustomer = this.$store.state.power.isSettlementCustomer == 'Y'
        if(this.$store.state.power.enterpriseVersion >= 100){
            this.getPriceShow()
        }
        let unwatch = this.$watch('$store.state.power', (val) => {
            this.isSettlementCustomer = val.isSettlementCustomer == 'Y'
            if(val.enterpriseVersion >= 100){
                this.getPriceShow()
            }
            this.power = val
            console.log(333)
            console.log(this.power)
            unwatch()
        })
    },
    watch: {
        'queryForm.customerTypes.selected'(val) {
            let tempArr = []
            val.map(item => {
                tempArr.push("'" + item + "'")
            })
            this.queryForm.customer.request.params.classifyID = tempArr.join(',')
            this.queryForm.customer.isReSearch = true
        },
        'queryForm.domainDesc.selected'(val) {
            let tempArr = []
            val.map(item => {
                tempArr.push("'" + item + "'")
            })
            this.queryForm.customer.request.params.domainID = tempArr.join(',')
            this.queryForm.customer.isReSearch = true
        },
        'params': {
            handler(newVal, oldVal) {
                // 需求#154：组合任意维度含 itemID/isLargess 即视为"带商品"（兼容 itemID_customerID 商品+客户 与 customerID_itemID 客户+商品 两种顺序）
                let hasItemDim = false
                if (newVal.code != null && newVal.code != 'billNo') {
                    hasItemDim = newVal.code.split('_').some(d => d === 'itemID' || d === 'isLargess')
                }
                if (hasItemDim) {
                    this.funcCode = 642
                    // 带商品
                    this.customColumnsList = [
                        {
                            label: "规格",
                            prop: "itemSpec"
                        },
                        {
                            label: "小单位条码",
                            prop: "invBarCode"
                        },
                        {
                            label: "中单位条码",
                            prop: "midBarCode"
                        },
                        {
                            label: "大单位条码",
                            prop: "salBarCode"
                        },
                        {
                            label: "销售数量",
                            prop: "saleQty",
                        },
                        {
                            label: "销售折算大单位",
                            prop: "saleDetailSalQtyFormat"
                        },
                        {
                            label: "销售折算中单位",
                            prop: "saleDetailMidQtyFormat"
                        },
                        {
                            label: "销售折算小单位",
                            prop: "saleDetailInvQtyFormat"
                        },
                        {
                            label: "销售重量(Kg)",
                            prop: "sellWeightStr"
                        },
                        {
                            label: "销售重量(吨)",
                            prop: "sellWeightStrTon"
                        },
                        {
                            label: "销售金额",
                            prop: "salTotalAmt",
                        },
                        {
                            label: "销售成本金额",
                            prop: "sellCostPrice",
                            power: ['allowCostPrice']
                        },
                        {
                            label: "退货数量",
                            prop: "returnQty",
                        },
                        {
                            label: "退货折算大单位",
                            prop: "returnDetailSalQtyFormat"
                        },
                        {
                            label: "退货折算中单位",
                            prop: "returnDetailMidQtyFormat"
                        },
                        {
                            label: "退货折算小单位",
                            prop: "returnDetailInvQtyFormat"
                        },
                        {
                            label: "退货重量(Kg)",
                            prop: "returnWeightStr"
                        },
                        {
                            label: "退货重量(吨)",
                            prop: "returnWeightStrTon"
                        },
                        {
                            label: "退货金额",
                            prop: "returnTotalAmt",
                        },
                        {
                            label: "还货数量",
                            prop: "backQty",
                        },
                        {
                            label: "还货折算大单位",
                            prop: "backDetailSalQtyFormat"
                        },
                        {
                            label: "还货折算中单位",
                            prop: "backDetailMidQtyFormat"
                        },
                        {
                            label: "还货折算小单位",
                            prop: "backDetailInvQtyFormat"
                        },
                        {
                            label: "还货重量(Kg)",
                            prop: "backWeightStr"
                        },
                        {
                            label: "还货重量(吨)",
                            prop: "backWeightStrTon"
                        },
                        {
                            label: "还货金额",
                            prop: "backTotalAmt",
                        },
                        {
                            label: "净销售数量",
                            prop: "netSaleQty",
                        },
                        {
                            label: "净销售大单位数量",
                            prop: "netSalQtyFormat"
                        },
                        {
                            label: "净销售中单位数量",
                            prop: "netMidQtyFormat"
                        },
                        {
                            label: "净销售小单位数量",
                            prop: "netInvQtyFormat"
                        },
                        {
                            label: "净重量(Kg)",
                            prop: "netWeight"
                        },
                        {
                            label: "净重量(吨)",
                            prop: "netWeightTon"
                        },
                        {
                            label: "净销售金额",
                            prop: "netSaleTotalAmt",
                        },
                        {
                            label: "成本金额",
                            prop: "costPrice",
                            power: ['allowCostPrice']
                        },
                        {
                            label: "小单位均价",
                            prop: "saleInvAvgPrice"
                        },
                        {
                            label: "大单位均价",
                            prop: "saleSalAvgPrice"
                        },
                        {
                            label: "毛利",
                            prop: "crossProfit",
                            power: ['allowCostPrice']
                        },
                        {
                            label: "毛利率",
                            prop: "crossProfitMargin",
                            power: ['allowCostPrice']
                        },
                        {
                            label: "退换货率",
                            prop: "returnLv"
                        },
                        {
                            label: "净退货率",
                            prop: "returnMeetLv"
                        },
                        {
                            label: "换货数量",
                            prop: "exchangeQty",
                        },
                        {
                            label: "延迟换货-借货数量",
                            prop: "exchangeMeetQty"
                        },
                        {
                            label: "延迟换货-还货数量",
                            prop: "exchangeBackQty",
                        }
                        // 需求#154：按统计维度追加客户/商品维度自定义列（默认隐藏）
                    ].concat(this.getNewDimColumns(newVal.code))
                    // {
                    //     label: "小单位总数量",
                    //     prop: "invAvgNum"
                    // },

                    // {
                    //     label: "总重量",
                    //     prop: "weightAllStr"
                    // },
                } else if (newVal.code != null && newVal.code === 'billNo') {
                    //单据
                    this.funcCode = 429
                    this.customColumnsList = [    
                        {
                            label: "关联单号",
                            prop: "sourceBillNo"
                        },
                        {
                            label: "对账单号",
                            prop: "reconciliationBillNo"
                        },
                        {
                            label: "客户编码",
                            prop: "customerCode"
                        },
                        {
                            label: "联系人",
                            prop: "boss"
                        },
                        {
                            label: "电话",
                            prop: "phoneNumber",
                        },
                        {
                            label: "地址",
                            prop: "address"
                        },
                        {
                            label: "配送员",
                            prop: "deliverUserName",
                        },
                        {
                            label: "欠款金额",
                            prop: "arrearAmt"
                        },
                        {
                            label: "剩余未结金额",
                            prop: "arrearbalance"
                        },
                        {
                            label: "单据来源",
                            prop: "isFromVehicle"
                        },
                        {
                            label: "制单人",
                            prop: "entryUserName"
                        },
                        {
                            label: "审核人",
                            prop: "recordedUserName"
                        },
                        {
                            label: "审核时间",
                            prop: "recordedDateTime"
                        },
                        {
                            label: "备注",
                            prop: "remark"
                        }
                        // 需求#154：单据同时含客户与商品维度 → 客户 8 列 + 商品 7 列（默认隐藏）
                    ].concat(this.getNewDimColumns(newVal.code))
                } else {
                    // 不带商品
                    this.funcCode = 643
                    this.customColumnsList = [    
                        {
                            label: "销售数量",
                            prop: "saleQty"
                        },
                        {
                            label: "销售折算小单位",
                            prop: "saleDetailInvQtyFormat"
                        },
                        {
                            label: "销售重量(Kg)",
                            prop: "sellWeightStr"
                        },
                        {
                            label: "销售重量(吨)",
                            prop: "sellWeightStrTon"
                        },
                        {
                            label: "销售金额",
                            prop: "salTotalAmt",
                        },
                        {
                            label: "销售成本金额",
                            prop: "sellCostPrice",
                            power: ['allowCostPrice']
                        },
                        {
                            label: "退货数量",
                            prop: "returnQty",
                        },
                        {
                            label: "退货折算小单位",
                            prop: "returnDetailInvQtyFormat"
                        },
                        {
                            label: "退货重量(Kg)",
                            prop: "returnWeightStr"
                        },
                        {
                            label: "退货重量(吨)",
                            prop: "returnWeightStrTon"
                        },
                        {
                            label: "退货金额",
                            prop: "returnTotalAmt"
                        },
                        {
                            label: "还货数量",
                            prop: "backQty"
                        },
                        {
                            label: "还货折算小单位",
                            prop: "backDetailInvQtyFormat"
                        },
                        {
                            label: "还货重量(Kg)",
                            prop: "backWeightStr"
                        },
                        {
                            label: "还货重量(吨)",
                            prop: "backWeightStrTon"
                        },
                        {
                            label: "还货金额",
                            prop: "backTotalAmt"
                        },
                        {
                            label: "净销售数量",
                            prop: "netSaleQty"
                        },
                        {
                            label: "净销售小单位数量",
                            prop: "netInvQtyFormat"
                        },
                        {
                            label: "净重量(Kg)",
                            prop: "netWeight"
                        },
                        {
                            label: "净重量(吨)",
                            prop: "netWeightTon"
                        },
                        {
                            label: "净销售金额",
                            prop: "netSaleTotalAmt"
                        },
                        {
                            label: "成本金额",
                            prop: "costPrice",
                            power: ['allowCostPrice']
                        },
                        {
                            label: "毛利",
                            prop: "crossProfit",
                            power: ['allowCostPrice']
                        },
                        {
                            label: "毛利率",
                            prop: "crossProfitMargin",
                            power: ['allowCostPrice']
                        },
                        {
                            label: "退换货率",
                            prop: "returnLv"
                        },
                        {
                            label: "净退货率",
                            prop: "returnMeetLv"
                        },
                        {
                            label: "换货数量",
                            prop: "exchangeQty"
                        },
                        {
                            label: "延迟换货-借货数量",
                            prop: "exchangeMeetQty"
                        },
                        {
                            label: "延迟换货-还货数量",
                            prop: "exchangeBackQty"
                        }
                        // 需求#154：按统计维度追加客户/商品维度自定义列（默认隐藏）
                    ].concat(this.getNewDimColumns(newVal.code))
                }
            },
            deep: true
        }
    },
    mounted() {
        window.top.addEventListener('message', this.messageOfSelect)
        this.getLabelData()
        // vue3 页面跳转过来时带 option（时间范围+客户），赋值后自动查询
        // source: customProfit=客户利润分析，customerFollowDecision=客户决策跟进报表
        if(this.option) {
            let op = JSON.parse(this.option)
            if(op.customerID && (op.source == 'customProfit' || op.source == 'customerFollowDecision')) {
                this.queryForm.billDate.selected = op.date
                this.queryForm.customer.selected = [{ value: op.customerID, text: op.customerName}]
                this.queryForm.customer.list = [{ value: op.customerID, text: op.customerName}]
                this.$nextTick(() => {
                    this.onSubmit()
                })
            } else {
                this.onSubmit()
            }
        } else {
            this.onSubmit()
        }
    },
    beforeDestroy() {
        // window.top.removeEventListener('message', this.messageOfSelect)
    },
    methods: {
        // 需求#154：按维度过滤列表表头，不含商品/客户的组合不显示对应维度的列表字段
        // 维度判定与 getNewDimColumns 保持一致：客户维度=customerID（片区 domainID、客户类别 classifyID、单据 billNo 不算客户维度）；商品维度=itemID/isLargess（单据 billNo 不算商品维度）
        filterHeaderListByDims(code, list) {
            if (!code || !Array.isArray(list)) return list || []
            let dims = code.split('_')
            if (dims.includes('billNo')) {
                // 单据：不显示客户/商品维度列
                const customerProps = CUSTOMER_DIM_COLUMNS.map(c => c.prop)
                const itemProps = ITEM_DIM_COLUMNS.map(c => c.prop)
                return list.filter(item => {
                    if (customerProps.includes(item.prop)) return false
                    if (itemProps.includes(item.prop)) return false
                    return true
                })
            }
            const hasCustomer = dims.some(d => d === 'customerID')
            const hasItem = dims.some(d => d === 'itemID' || d === 'isLargess')
            const customerProps = CUSTOMER_DIM_COLUMNS.map(c => c.prop)
            const itemProps = ITEM_DIM_COLUMNS.map(c => c.prop)
            return list.filter(item => {
                if (!hasCustomer && customerProps.includes(item.prop)) return false
                if (!hasItem && itemProps.includes(item.prop)) return false
                return true
            })
        },
        // 需求#154：根据统计维度返回应新增的客户/商品维度自定义列（不是所有维度都加）
        // 涉及客户维度（customerID，片区 domainID、客户类别 classifyID、单据 billNo 不算客户维度）→ 客户 8 列；涉及商品维度（itemID/isLargess，单据 billNo 不算商品维度）→ 商品 7 列；同时涉及 → 两类全加；都不涉及 → 不加
        // 注意：brandID/itemTypeID/financialBrandID 等只是商品属性维度（分组用），不算"含商品"
        getNewDimColumns(code) {
            if (!code) return []
            let dims = code.split('_')
            // 单据：不新增客户/商品维度列
            if (dims.includes('billNo')) {
                return []
            }
            const hasCustomer = dims.some(d => d === 'customerID')
            const hasItem = dims.some(d => d === 'itemID' || d === 'isLargess')
            let cols = []
            if (hasCustomer) cols = cols.concat(CUSTOMER_DIM_COLUMNS)
            if (hasItem) cols = cols.concat(ITEM_DIM_COLUMNS)
            return cols
        },
        // 查询客户标签列表
        async getLabelData() {
            const { data: res } = await this.$http.post('/Account/pubLabelDefineVue/selectLabelList.html', this.Qs.stringify({ labelType: '001' }))
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.queryForm.label.list = JSON.parse(res.result.data).map(item => {
                item.text = item.labelDesc
                item.value = item.id
                return item
            })
            // 需求#154：商品类型（labelType=002）、价格带（labelType=003）
            const { data: res2 } = await this.$http.post('/Account/pubLabelDefineVue/selectLabelList.html', this.Qs.stringify({ labelType: '002' }))
            if (res2.code == 'success') {
                res2.result = JSON.parse(res2.result)
                this.queryForm.productLabelIds.list = JSON.parse(res2.result.data).map(item => {
                    item.text = item.labelDesc
                    item.value = item.id
                    return item
                })
            }
            const { data: res3 } = await this.$http.post('/Account/pubLabelDefineVue/selectLabelList.html', this.Qs.stringify({ labelType: '003' }))
            if (res3.code == 'success') {
                res3.result = JSON.parse(res3.result)
                this.queryForm.priceBandLabelId.list = JSON.parse(res3.result.data).map(item => {
                    item.text = item.labelDesc
                    item.value = item.id
                    return item
                })
            }
        },
        async getEntrySet() {
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/entrySettings/selectEntrySettingsList.html', { functionID: 213, type: 2 })
            if(res.code != '0') return this.isCollapse = false
            let num = res.data.operate.contentList.findIndex(it => it.code == 'isOpenSearchPage')
            this.isCollapse = num == -1 ? false : (res.data.operate.contentList[num].value == 'Y' ? false : true)
            console.log(this.isCollapse, res.data.operate.contentList[num])
        },
        async setEnter() {
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/entrySettings/saveOperateHabit.html', { functionID: 213,  isOpenSearchPage: this.isCollapse ? 'Y' : 'N' })
            if(res.code != '0') return this.$message.error(res.message)
            this.isCollapse = !this.isCollapse
        },
        async getPriceShow() {
            const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
            this.allowCostPrice = res.result == 'Y'
        },
        // 获取组合
        async getComposeList() {
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/sale/collect/selectSaleMenuList.html')
            if (res.code != '0') return this.$message.error(res.message)
            res.data.forEach(it => {
                this.tabsNavList.map(item => {
                    if (it.parentCode == item.code) {
                        // console.log(item)
                        item.subList.push(it)
                    }
                    if (it.code == item.code) {
                        item.list = it.list
                    }
                    return item
                })
            })
            this.params.code = this.tabsNavList[this.tabsIndex].code
            this.tableHeaderList = this.filterHeaderListByDims(this.params.code, this.tabsNavList[this.tabsIndex].list)
            this.$nextTick(() => {
                // this.$refs[this.tabsName].getTableColumn()
                this.$refs[this.tabsName][0].getTableList()
                this.$refs[this.tabsName][0].getCustomColumnsList()
            })
        },
        async getSelectList() {
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/sale/collect/saleCollectUserMenu.html')
            if (res.code != '0') return this.$message.error(res.message)
            this.selectList = res.data
        },
        onReset() {
            this.$refs['queryFormRef'].resetFields()
        },
        onSubmit() {
            console.log('首提交')
            // this.salesman = this.queryForm.salesman.selected.length ? this.queryForm.salesman.selected.map(item => (item.text)) : '全部'
            // this.inWarehouse = this.queryForm.inWarehouse.selected.length ? this.queryForm.inWarehouse.selected.map(item => (item.text)) : '全部'
            // this.isLargess = this.queryForm.isLargess.selected.length ? this.queryForm.isLargess.selected.map(item => (item.text)) : '全部'
            this.transmitQuery = JSON.parse(JSON.stringify(this.queryForm))

            // console.log(this.queryForm)
            for (let i in this.queryForm) {
                if (typeof this.queryForm[i].selected == 'object') {
                    if (i == 'billDate') {
                        if (this.queryForm[i].selected) {
                            this.$set(this.params, 'beginDate', this.queryForm[i].selected[0])
                            this.$set(this.params, 'endDate', this.queryForm[i].selected[1])
                        } else {
                            this.$set(this.params, 'beginDate', '')
                            this.$set(this.params, 'endDate', '')
                        }
                        continue
                    }

                    let tempArr = []
                    this.queryForm[i].selected.map(item => {
                        if (this.queryForm[i].valueIsObj) {
                            tempArr.push("'" + item.value + "'")
                        } else {
                            tempArr.push("'" + item + "'")
                        }
                    })

                    this.$set(this.params, this.queryForm[i].submitName, tempArr.join(','))
                } else {
                    this.$set(this.params, this.queryForm[i].submitName, this.queryForm[i].selected)
                }
            }
            this.params.page = 1
            this.$nextTick(() => {
                this.$refs[this.tabsName][0].getTableList()
                this.$refs[this.tabsName][0].getCustomColumnsList()
            })
        },
        productInputFocus() {
            this.$refs['productSelectRef'].blur()
            window.top.openDialog55('选择商品', '/Account/sys/common/productSelect.html?tag=SaleReportDimensionProduct&isFitterEnabled=N')
        },
        customerInputFocus() {
            this.$refs['customerSelectRef'].blur()
            window.top.openDialog55('选择客户', '/Account/sys/common/customerSelect.html?isFitterEnabled=N&tag=SaleReportDimensionCustomer')
        },
        // 接受子页面数据
        messageOfSelect(e) {
            let { data: res } = e
            if (res.tag == 'SaleReportDimensionProduct') {
                if (res.code != 'success') return false
                // console.log(this.$refs['productSelectRef'])
                this.$set(this.queryForm.product, 'list', res.data)
                // this.queryForm.product.selected = res.data.map(item => (item.value))
                this.queryForm.product.selected = res.data
                top.layer.closeAll('iframe')
            } else if (res.tag == 'SaleReportDimensionCustomer') {
                if (res.code != 'success') return false
                // console.log(this.$refs['productSelectRef'])
                this.$set(this.queryForm.customer, 'list', res.data)
                // this.queryForm.product.selected = res.data.map(item => (item.value))
                this.queryForm.customer.selected = res.data
                top.layer.closeAll('iframe')
            }
        },
        getCustomColumns(customColumn) {
            this.dialogVisible = true
            // let tempArr = [...customColumn]
            let tempArr = JSON.parse(JSON.stringify(customColumn))
            this.$nextTick(() => {
                let element = this.$refs['customColumns']
                element.loading = false
                element.setCustomcolumns(tempArr)
            })
        },

        dialogClose(isSubmit) {
            if(!isSubmit){
                this.dialogVisible = false
                return
            }
            let $customColumns = this.$refs['customColumns']
            $customColumns.$nextTick(async () => {
                let { customColumns } = $customColumns
                // 以弹窗当前顺序提交，每项写入 sort（与数组下标一致），供自定义列按用户顺序回显
                const info = (customColumns || []).map((item, index) => {
                    return Object.assign({}, item, { sort: index })
                })
                const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
                    funcCode: this.funcCode,
                    customSetInfo: JSON.stringify(info)
                }))
                if (res.code != 'success') return this.$message.error(res.message)
                this.$message.success(res.message)
                this.dialogVisible = false
                this.$refs[this.tabsName][0].getCustomColumnsList()
            })
        },
        exportExcel(flag) {
            this.$nextTick(() => {
                this.$refs[this.tabsName][0].exportTableExcel(flag)
            })
        },
        handleClick() {
            console.log(this.tabsName)
            let index = this.tabsNavList.findIndex(item => item.code == this.tabsName)
            if (index > -1) this.tabsIndex = index
            this.makeUpIndex = null
            if(this.tabsName == 'billNo') {
                this.activeName = 'query'
                this.tableHeaderList = []
            } else {
                this.tableHeaderList = this.filterHeaderListByDims(this.tabsNavList[this.tabsIndex].code, this.tabsNavList[this.tabsIndex].list)
            }
            this.params.code = this.tabsNavList[this.tabsIndex].code
            this.params.page = 1
            this.$nextTick(() => {
                this.$refs[this.tabsName][0].getTableList()
                this.$refs[this.tabsName][0].getCustomColumnsList()
            })
        },
        toMakeUp(item, index) {
            this.makeUpIndex = index
            this.params.code = item.code
            this.params.page = 1
            this.tableHeaderList = this.filterHeaderListByDims(item.code, item.list)
            this.$nextTick(() => {
                this.$refs[this.tabsName][0].getTableList()
                this.$refs[this.tabsName][0].getCustomColumnsList()
            })
        },
        toSelect: debounce(async function (index) {
            let isSelect = this.tabsNavList[this.tabsIndex].subList[index].isSelect == 'Y' ? 'N' : 'Y'
            let menuCode = this.tabsNavList[this.tabsIndex].subList[index].code
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/sale/collect/insetSaleCollectUserMenu.html', { isSelect: isSelect, menuCode: menuCode })
            if (res.code != '0') return this.$message.error(res.message)
            this.$message.closeAll()
            let message = isSelect == 'Y' ? '收藏成功' : '取消收藏成功'
            this.$message.success(message)
            this.$set(this.tabsNavList[this.tabsIndex].subList[index], 'isSelect', isSelect)
            this.getSelectList()
        }, 300, true),
        handleCommand(e) {
            this.params.code = e.code
            this.tabsName = e.parentCode
            let index = this.tabsNavList.findIndex(item => item.code == this.tabsName)
            if (index > -1) {
                this.tabsIndex = index
                let num = this.tabsNavList[this.tabsIndex].subList.findIndex(item => item.code == e.code)
                if (num > -1) {
                    this.makeUpIndex = num
                    this.tableHeaderList = this.filterHeaderListByDims(this.tabsNavList[this.tabsIndex].subList[num].code, this.tabsNavList[this.tabsIndex].subList[num].list)
                }
            }
            this.params.page = 1
            this.$nextTick(() => {
                this.$refs[this.tabsName][0].getTableList()
                this.$refs[this.tabsName][0].getCustomColumnsList()
            })
        },
        brandChange(val) {
            let str = val.map(item => "'" + item.value + "'").join(',')
            this.queryForm.brandType.request.params['brandID'] = str
            this.queryForm.brandType.isReSearch = true
        },
    }
};
</script>
<style scoped lang="less">
#tab {
    .isCollapse {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        border: 1px #DCDFE6 solid;
        cursor: pointer;
        background-color: rgba(83, 168, 255, 0.1);
        color: #409EFF;
    }

    /deep/.aside-box {
        height: 100%;
        overflow: hidden;

        .select_multiple {
            ::v-deep .el-select__tags {
                max-height: 80px;
                overflow-y: auto;
                overflow-x: hidden;
            }
        }

        .date-box {
            .el-input__inner {
                padding-left: 5px;
                padding-right: 3px;
            }
        }
        .el-card {
            height: calc(100% - 2px);
        }

        .el-card__header {
            padding: 12px;
        }

        .el-card__body {
            padding: 0 0 6px;
            height: calc(100% - 6px);
            position: relative;
        }

        .el-tabs {
            height: 100%;
        }

        .el-tabs__content {
            // padding: 0 6px;
            height: calc(100% - 41px - 15px);
        }

        .el-tab-pane {
            height: 100%;
        }

        .el-form {
            height: 100%;

            .el-form-item {
                padding: 0 12px 0 0;
            }
        }

        .el-scrollbar {
            height: calc(100% - 40px);
        }

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        .el-scrollbar__bar {
            z-index: 999;
        }

        .table-header {
            height: 50px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 12px;

            p {
                font-size: 17px;
                font-weight: bolder;
            }
        }

        .table-list {
            padding: 0 12px;

            .item {
                height: 40px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                p {
                    font-size: 14px;
                    flex: 1;
                    cursor: pointer;
                    color: #333;

                    &.active {
                        color: #409EFF;
                    }
                }
            }
        }
    }

    /deep/.product-dialog {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        top: 50%;
        transform: translateY(-50%);
    }


    /deep/.main-box {
        padding: 0 20px;

        .tabs-card {
            height: calc(100% - 2px);

            .el-tabs__item {
                height: 32px;
                line-height: 32px;
            }

            .el-tabs__content {
                padding: 0 12px;
                height: calc(100% - 33px);

                .el-tab-pane {
                    height: calc(100% - 56px - 24px);
                }
            }
        }

        .el-card {
            margin: 12px 0;
        }

        .el-card__body {
            padding: 6px 12px;

            .el-form-item {
                margin-bottom: 0;
            }
        }

        // .el-pagination {
        //     margin-top: 16px;
        // }
    }
}

.label-box-item {
    display: flex;
    >div:nth-child(1) {
        margin-right: 10px;
    }
}
</style>